import MuiSnackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';

const StyledMuiSnackbar = styled(MuiSnackbar)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    maxWidth: '50vw',
    minWidth: theme.spacing(35),
  },
  [theme.breakpoints.down('md')]: {
    transform: 'unset',
    left: theme.spacing(1),
    right: theme.spacing(1),
  },
  '& .SBAlert': {
    width: '100%',
    padding: theme.spacing(0.25, 2),
    borderRadius: theme.spacing(0.5),
  },
}));

export default StyledMuiSnackbar;
